import { render } from "./KanoonCourseContent.vue?vue&type=template&id=9ccac44a&scoped=true"
import script from "./KanoonCourseContent.vue?vue&type=script&lang=js"
export * from "./KanoonCourseContent.vue?vue&type=script&lang=js"

import "./KanoonCourseContent.vue?vue&type=style&index=0&id=9ccac44a&scoped=true&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ccac44a"],['__file',"KanoonCourseContent.vue"]])

export default __exports__